import Model from 'flarum/common/Model';
export default class ArenaBattle extends Model {
  discussionId() {
    return Model.attribute('discussionId').call(this);
  }
  challengerId() {
    return Model.attribute('challengerId').call(this);
  }
  opponentId() {
    return Model.attribute('opponentId').call(this);
  }
  // Which deck slot each side locked in at battle creation (see
  // CreateBattleController) — the card slider reads through these to show
  // the right deck, not whatever the player currently has selected as
  // their default in the profile editor.
  challengerDeckSlotId() {
    return Model.attribute('challengerDeckSlotId').call(this);
  }
  opponentDeckSlotId() {
    return Model.attribute('opponentDeckSlotId').call(this);
  }
  // True once the opponent has explicitly confirmed/picked their own deck
  // slot (rather than just having one auto-locked for them) — see
  // BattleResource::fields() / addCardSlider.tsx's auto-open check.
  opponentDeckConfirmed() {
    return Model.attribute('opponentDeckConfirmed').call(this);
  }
  challengerMana() {
    return Model.attribute('challengerMana').call(this);
  }
  opponentMana() {
    return Model.attribute('opponentMana').call(this);
  }
  nextPlayerId() {
    return Model.attribute('nextPlayerId').call(this);
  }
  currentTurn() {
    return Model.attribute('currentTurn').call(this);
  }
  status() {
    return Model.attribute('status').call(this);
  }
  expiresAt() {
    return Model.attribute('expiresAt').call(this);
  }
  drawProposedById() {
    return Model.attribute('drawProposedById').call(this);
  }
  drawProposedAt() {
    return Model.attribute('drawProposedAt').call(this);
  }
}
flarum.reg.add('forumaker-arena', 'common/models/ArenaBattle', ArenaBattle);